const action_types = require('./action-types');
const api = require('./api');

const initialState = {
  message: api.getMessage(), // Loads default language content (en) as an initial state
  showMenu: true,
  locale:api.getLocale()
};

let reducer = function (state = initialState, action) {
  switch (action.type) {
    case action_types.SWITCH_LANGUAGE:      
      return {
        message: api.getMessage(action.language),
        showMenu: state.showMenu,
        locale:action.language
      };
    case action_types.TOGGLE_MENU:      
      return {
        message: state.message,
        showMenu: !state.showMenu
      };
    default:
      return state;
  }
};

module.exports = reducer;



// WEBPACK FOOTER //
// ./src/reducer.js